module.exports = __webpack_public_path__ + "static/media/RSCapstone.2cea6a18.png";